import { defineStore } from "pinia";
import { ref } from "vue";
import type { RuntimeConfig } from "@/config";

/**
 * La configuración de runtime, ya cargada. Se fija una vez durante el arranque y
 * después es sólo lectura.
 */
export const useConfigStore = defineStore("config", () => {
  const config = ref<RuntimeConfig | null>(null);

  function set(value: RuntimeConfig) {
    config.value = value;
  }

  /** Lanza si se lee antes de que el arranque la haya fijado. */
  function require(): RuntimeConfig {
    if (!config.value) {
      throw new Error("La configuración se leyó antes de cargarla");
    }
    return config.value;
  }

  return { config, set, require };
});
